import { all } from 'redux-saga/effects';
import { authSagas } from './auth.saga';
import { shiftsSagas } from './shifts.saga';
import { talentSagas } from './talent.saga';
import { companiesSagas } from './company.saga';
import { skillsSagas } from './skills.saga';
import { rejectedUserSagas } from './rejected-user.saga';
import { appSettingsSagas } from './settings.saga';

export default function* rootSaga() {
    yield all([
        ...authSagas,
        ...talentSagas,
        ...shiftsSagas,
        ...companiesSagas,
        ...appSettingsSagas,
        ...skillsSagas,
        ...rejectedUserSagas,
    ]);
}
